module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/expediente-interviniente/expediente-interviniente.component.css
// module id = ./src/app/components/expediente-interviniente/expediente-interviniente.component.css
// module chunks = main